import React, { useState, useEffect, useRef } from 'react';
import ColorfulIcon from './ColorfulIcon';
import { impactStats } from '../mockData';

const iconGradients = ['blue', 'green', 'purple', 'orange'];

const ImpactStats = () => {
  const [counts, setCounts] = useState(impactStats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          animateCounters();
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [hasAnimated]);

  const animateCounters = () => {
    impactStats.forEach((stat, index) => {
      let current = 0;
      const increment = stat.value / 50;
      const timer = setInterval(() => {
        current += increment;
        if (current >= stat.value) {
          current = stat.value;
          clearInterval(timer);
        }
        setCounts((prevCounts) => {
          const newCounts = [...prevCounts];
          newCounts[index] = Math.floor(current);
          return newCounts;
        });
      }, 40);
    });
  };

  return (
    <section ref={sectionRef} className="py-6 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-6">
          <p className="text-blue-600 text-sm font-semibold tracking-wider uppercase mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>
            Our Impact
          </p>
          <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif', letterSpacing: '-0.02em' }}>
            Numbers That Speak
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {impactStats.map((stat, index) => {
            return (
              <div
                key={stat.id}
                className="bg-gray-50 border border-gray-200 rounded-3xl p-8 text-center hover:shadow-lg transition-all duration-300"
              >
                <div className="flex justify-center mb-4">
                  <ColorfulIcon 
                    icon={stat.icon} 
                    size={28} 
                    gradient={iconGradients[index % iconGradients.length]} 
                  />
                </div>
                <div className="text-5xl font-semibold text-gray-900 mb-2 mt-3" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>
                  {counts[index]}{stat.suffix}
                </div>
                <div className="text-lg font-medium text-gray-900 mb-2" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Display, sans-serif' }}>{stat.label}</div>
                <div className="text-sm text-gray-600" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, SF Pro Text, sans-serif' }}>{stat.subtitle}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;